<svg height="30px" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 600 1014.77">
    <defs>
        <style>
            .cls-2 {
                font-size: 534px;
                fill: #fff;
                font-family: Lato-Bold, Lato;
                font-weight: 700;
            }
        </style>
    </defs>
    <circle cx="300" cy="196.11" r="196.11" />
    <path d="M254.72,433h90.57A254.72,254.72,0,0,1,600,687.72V926.87a77.83,77.83,0,0,1-77.83,77.83H77.83A77.83,77.83,0,0,1,0,926.87V687.72A254.72,254.72,0,0,1,254.72,433Z" />
    <text class="cls-2" transform="translate(74.15 918.38) scale(1.28 1)" *ngIf="number">{{ number }}</text>
</svg>
